import React from 'react'
import LegalLayout from '../../components/LegalLayout'

/** 이용약관. URL: /terms */
const TermsPage: React.FC = () => {
  return (
    <LegalLayout>
      <h1>TASTEE 이용약관</h1>

      <h2>제1조 (목적)</h2>
      <p>
        본 약관은 TASTEE 서비스(이하 "서비스")의 이용과 관련하여 회사와 이용자 간의
        권리, 의무 및 책임사항을 규정함을 목적으로 합니다.
      </p>

      <h2>제2조 (정의)</h2>
      <ul>
        <li>
          "서비스"란 TASTEE가 제공하는 음식점 등 방문 기록의 작성·보관, 친구 간 공유
          및 이에 부수하는 모든 서비스를 의미합니다.
        </li>
        <li>
          "회원"이란 본 약관에 동의하고 휴대전화번호 인증을 완료하여 서비스 이용
          자격을 부여받은 자를 의미합니다.
        </li>
        <li>
          "게시물"이란 회원이 서비스에 게시한 사진, 텍스트, 평가, 태그 등 모든 형태의
          콘텐츠를 의미합니다.
        </li>
      </ul>

      <h2>제3조 (약관의 효력 및 변경)</h2>
      <ul>
        <li>본 약관은 서비스를 이용하고자 하는 모든 회원에게 효력이 발생합니다.</li>
        <li>
          회사는 관련 법령을 위배하지 않는 범위에서 본 약관을 변경할 수 있으며, 변경
          시 적용일자 및 변경 사유를 명시하여 적용일 7일 전부터 서비스 내 공지사항을
          통해 공지합니다. 다만 회원에게 불리한 변경의 경우 30일 전부터 공지하고 앱
          푸시 알림 등으로 개별 통지합니다.
        </li>
        <li>
          회원이 변경된 약관의 적용일까지 거부 의사를 표시하지 않고 서비스를 계속
          이용하는 경우 변경된 약관에 동의한 것으로 봅니다. 변경된 약관에 동의하지
          않는 회원은 이용계약을 해지할 수 있습니다.
        </li>
      </ul>

      <h2>제4조 (이용계약의 체결)</h2>
      <ul>
        <li>
          이용계약은 가입 희망자가 본 약관에 동의하고 휴대전화번호 인증을 완료한 때
          성립합니다. 카카오, 네이버, 애플, 구글 계정을 통한 소셜 로그인의 경우에도
          동일합니다.
        </li>
        <li>
          회사는 다음 각 호에 해당하는 경우 가입을 승낙하지 않거나 사후에 이용계약을
          해지할 수 있습니다:
          <ul>
            <li>만 14세 미만인 경우</li>
            <li>타인의 전화번호 또는 계정 정보를 도용한 경우</li>
            <li>과거 본 약관 위반으로 이용이 제한된 이력이 있는 경우</li>
            <li>기타 부정한 목적으로 가입을 신청한 경우</li>
          </ul>
        </li>
      </ul>

      <h2>제5조 (서비스의 제공)</h2>
      <ul>
        <li>
          회사는 다음과 같은 서비스를 제공합니다:
          <ul>
            <li>음식점 등 방문 기록의 작성·보관·아카이빙 서비스</li>
            <li>친구 간 기록 공유 및 추천 열람 서비스</li>
            <li>친구 찾기, 태그, 알림 등 소셜 기능</li>
            <li>기타 회사가 정하는 서비스</li>
          </ul>
        </li>
        <li>
          서비스는 연중무휴, 1일 24시간 제공함을 원칙으로 합니다. 다만 시스템 점검,
          장애, 통신 두절 등의 사유로 일시 중단될 수 있으며, 사전에 공지가 가능한
          경우 공지합니다.
        </li>
      </ul>

      <h2>제6조 (이용자의 의무)</h2>
      <p>이용자는 다음 행위를 하여서는 안 됩니다:</p>
      <ul className="bullets">
        <li>신청 또는 변경시 허위 내용의 등록</li>
        <li>타인의 정보 도용</li>
        <li>회사가 게시한 정보의 변경</li>
        <li>
          회사가 정한 정보 이외의 정보(컴퓨터 프로그램 등) 등의 송신 또는 게시
        </li>
        <li>회사 기타 제3자의 저작권 등 지적재산권에 대한 침해</li>
        <li>회사 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위</li>
        <li>
          사실과 다른 내용으로 특정 업소를 비방하거나, 대가를 받고 작성한 사실을 숨긴
          허위·과장 기록의 게시
        </li>
      </ul>

      <h2>
        제7조 (부적절한 콘텐츠 및 남용 행위에 대한 제로 톨러런스)
      </h2>
      <ul>
        <li>
          회사는 부적절한 콘텐츠 및 남용 행위에 대하여 제로 톨러런스(Zero Tolerance)
          정책을 적용합니다.
        </li>
        <li>
          부적절한 콘텐츠란 다음을 포함합니다:
          <ul>
            <li>성적, 폭력적, 혐오적 내용</li>
            <li>차별적이거나 괴롭힘을 조장하는 내용</li>
            <li>불법적이거나 유해한 내용</li>
            <li>타인의 권리를 침해하는 내용</li>
            <li>허위 정보나 오해의 소지가 있는 내용</li>
            <li>기타 공서양속에 반하는 내용</li>
          </ul>
        </li>
        <li>
          남용 행위란 다음을 포함합니다:
          <ul>
            <li>다른 이용자를 괴롭히거나 위협하는 행위</li>
            <li>스팸, 도배, 반복적인 무의미한 메시지 전송</li>
            <li>사기, 기만, 허위 정보 제공</li>
            <li>서비스의 정상적인 운영을 방해하는 행위</li>
            <li>
              기타 다른 이용자에게 불쾌감을 주거나 서비스 이용을 방해하는 행위
            </li>
          </ul>
        </li>
        <li>
          이용자가 부적절한 콘텐츠를 게시하거나 남용 행위를 하는 경우, 회사는 사전
          통보 없이 즉시 다음 조치를 취할 수 있습니다:
          <ul>
            <li>해당 콘텐츠의 즉시 삭제</li>
            <li>해당 이용자의 서비스 이용 제한 또는 계정 정지</li>
            <li>관련 법령에 따른 법적 조치</li>
          </ul>
        </li>
        <li>
          회사는 이용자 신고를 받은 경우, 24시간 이내에 신고 내용을 검토하고 필요한
          조치를 취합니다.
        </li>
        <li>
          이용자는 부적절한 콘텐츠나 남용 행위를 발견한 경우 서비스 내 신고 기능을
          통해 신고할 수 있으며, 특정 이용자를 차단하여 해당 이용자의 콘텐츠가
          표시되지 않도록 할 수 있습니다.
        </li>
        <li>본 조에 따라 회사가 취한 정당한 조치에 대하여 회사는 책임을 지지 않습니다.</li>
      </ul>

      <h2>제8조 (게시물의 저작권)</h2>
      <ul>
        <li>회원이 작성한 게시물의 저작권은 해당 회원에게 귀속됩니다.</li>
        <li>
          회원은 게시물을 서비스에 게시함으로써, 회사가 서비스의 운영·개선·홍보를
          위해 필요한 범위 내에서 해당 게시물을 저장·복제·수정·전시·배포할 수 있는
          무상의 비독점적 이용권을 회사에 부여합니다. 회사가 게시물을 서비스 외부에
          이용하는 경우 사전에 회원의 동의를 받습니다.
        </li>
        <li>
          위 이용권은 회원 탈퇴 또는 게시물 삭제 시 종료됩니다. 다만 다른 회원의
          기록에 정상적으로 결합된 부분(태그 등)은 예외로 할 수 있습니다.
        </li>
      </ul>

      <h2>제9조 (개인정보보호)</h2>
      <p>
        회사는 관련법령이 정하는 바에 따라서 이용자 등록정보를 포함한 이용자의
        개인정보를 보호하기 위해 노력합니다. 이용자의 개인정보보호에 관해서는 관련법령
        및 회사가 정하는 개인정보처리방침에 정한 바에 의합니다.
      </p>

      <h2>제10조 (이용제한 및 계약해지)</h2>
      <ul>
        <li>
          회사는 회원이 본 약관을 위반한 경우 경고, 일시 이용정지, 영구 이용정지 등
          단계적으로 이용을 제한할 수 있습니다. 다만 법령 위반 등 중대한 사유가 있는
          경우 즉시 영구 이용정지할 수 있습니다.
        </li>
        <li>회원은 언제든지 서비스 내 탈퇴 기능을 통해 이용계약을 해지할 수 있습니다.</li>
        <li>
          탈퇴 시 회원의 개인정보 및 게시물은 개인정보처리방침 및 관련 법령에 따라
          처리됩니다.
        </li>
      </ul>

      <h2>제11조 (면책조항)</h2>
      <ul>
        <li>
          회사는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는
          경우에는 서비스 제공에 관한 책임이 면제됩니다.
        </li>
        <li>
          회사는 이용자의 귀책사유로 인한 서비스 이용의 장애에 대하여는 책임을 지지
          않습니다.
        </li>
        <li>
          회사는 회원이 게시한 정보·자료의 신뢰도, 정확성에 대해 보증하지 않으며, 회원
          간 또는 회원과 제3자 간에 발생한 분쟁에 개입할 의무가 없습니다.
        </li>
      </ul>

      <h2>제12조 (준거법 및 관할법원)</h2>
      <p>
        본 약관은 대한민국 법률에 따라 규율되고 해석되며, 회사와 이용자 간에 발생한
        분쟁에 관한 소송은 민사소송법상의 관할법원에 제소합니다.
      </p>

      <p>
        <strong>본 약관은 2026년 7월 28일부터 시행합니다.</strong>
      </p>
    </LegalLayout>
  )
}

export default TermsPage
